// Shared status for read requests. No URLs, credentials or response bodies appear in the notice.
const requests = new Map();
const subscribers = new Set();
let snapshot = { loading: 0, errors: [] };
export const apiLoadSnapshot = () => snapshot;
export const subscribeApiLoads = (listener) => {
  subscribers.add(listener);
  return () => subscribers.delete(listener);
};
export function setApiLoadState(id, state) {
  if (state) requests.set(id, state); else requests.delete(id);
  snapshot = {
    loading: [...requests.values()].filter(r => r.loading).length,
    errors: [...requests.values()].filter(r => r.error),
  };
  subscribers.forEach(listener => listener());
}
